var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignStatsUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.72039 12.8871C4.50179 12.1057 5.5616 11.6667 6.66667 11.6667H13.3333C14.4384 11.6667 15.4982 12.1057 16.2796 12.8871C17.061 13.6685 17.5 14.7283 17.5 15.8334V17.5001C17.5 17.9603 17.1269 18.3334 16.6667 18.3334C16.2064 18.3334 15.8333 17.9603 15.8333 17.5001V15.8334C15.8333 15.1704 15.5699 14.5345 15.1011 14.0656C14.6323 13.5968 13.9964 13.3334 13.3333 13.3334H6.66667C6.00363 13.3334 5.36774 13.5968 4.8989 14.0656C4.43006 14.5345 4.16667 15.1704 4.16667 15.8334V17.5001C4.16667 17.9603 3.79357 18.3334 3.33333 18.3334C2.8731 18.3334 2.5 17.9603 2.5 17.5001V15.8334C2.5 14.7283 2.93899 13.6685 3.72039 12.8871Z",
    fill: "#161719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 17.3999C2.5 16.8476 2.94772 16.3999 3.5 16.3999H16.5C17.0523 16.3999 17.5 16.8476 17.5 17.3999C17.5 17.9522 17.0523 18.3999 16.5 18.3999H3.5C2.94772 18.3999 2.5 17.9522 2.5 17.3999Z",
    fill: "#161719"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99992 3.33341C8.61921 3.33341 7.49992 4.4527 7.49992 5.83341C7.49992 7.21413 8.61921 8.33341 9.99992 8.33341C11.3806 8.33341 12.4999 7.21413 12.4999 5.83341C12.4999 4.4527 11.3806 3.33341 9.99992 3.33341ZM5.83325 5.83341C5.83325 3.53223 7.69873 1.66675 9.99992 1.66675C12.3011 1.66675 14.1666 3.53223 14.1666 5.83341C14.1666 8.1346 12.3011 10.0001 9.99992 10.0001C7.69873 10.0001 5.83325 8.1346 5.83325 5.83341Z",
    fill: "#161719"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignStatsUser);
export default __webpack_public_path__ + "static/media/campaign-stats-user.375637adf239d077ec33f8f2e8b58f8c.svg";
export { ForwardRef as ReactComponent };